<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-error-connection">
            <div class="main-text mb-5">
                Интернет-соединение потеряно
            </div>
            <div class="main-text mb-5">
                Проверьте подключение к интернету и повторите попытку
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalConnect",
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-error-connection.v-card {
    padding: 0;
    background: var(--rh-white-color);
    box-shadow: 0px 2px 15px rgba(37, 37, 37, 0.1);
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>